import ViewMore from './view-more';
export default ViewMore;